<template>
<!--  <div>-->
    <!--    <span>{{ fieldsData.label }}</span>-->
    <b-form-group  >
      <label v-html="fieldsData.label[selectlang]"></label>

      <b-form-textarea
          :maxLength="fieldsData.maxLength"
          :minLength="fieldsData.minLength"
                       :value="fieldsData.id"
                       :required="isRequired(fieldsData.required)"
                       @input="UpdateValue($event)"
                       :placeholder="fieldsData.hint[selectlang]"
                       class="form-control"/>
      <small class="text-danger" v-if="errorshow">{{ fieldsData.error[selectlang] }}</small>
      <!--      </validation-provider>-->
    </b-form-group>
<!--  </div>-->
</template>

<script>
export default {
  // props: {
  //   fieldsData: {
  //     // type: Object,
  //     // default: () => fieldsData,
  //   },
  // },
  props: ['fieldsData','selectlang'],

  data() {
    return {

      errorshow:false,
    };
  },
  methods: {
    isRequired(requiredValue) {

      // Check if fieldsData.required is equal to 1
      return requiredValue == 1;
    },
    UpdateValue(value) {
      // console.log(value);
      this.$emit('input', value)
      const lenmax =this.fieldsData.maxLength;
      const lenmin=this.fieldsData.minLength;
      const lenval=value.length
      this.$emit('input',value)
      if (lenval < lenmin || lenval > lenmax){
        this.errorshow=true;
      }
      else
      {
        this.errorshow=false;
      }
    },
  },
}
</script>

<style>
/* Add your styles here */
</style>
